import { render, staticRenderFns } from "./download-questionnaire.vue?vue&type=template&id=b0d5d8d8"
import script from "./download-questionnaire.vue?vue&type=script&lang=js"
export * from "./download-questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports